var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7823 0.217449C17.681 0.116704 17.5532 0.046952 17.4137 0.0163941C17.2742 -0.0141638 17.1288 -0.00425713 16.9948 0.0449493L0.494756 6.04495C0.352458 6.09892 0.229946 6.19491 0.143495 6.32017C0.0570431 6.44542 0.0107422 6.59401 0.0107422 6.7462C0.0107422 6.89839 0.0570431 7.04698 0.143495 7.17223C0.229946 7.29749 0.352458 7.39348 0.494756 7.44745L6.93726 10.0199L11.6923 5.24995L12.7498 6.30745L7.97226 11.085L10.5523 17.5275C10.6078 17.667 10.704 17.7866 10.8284 17.8709C10.9528 17.9551 11.0995 18.0001 11.2498 18C11.4013 17.9968 11.5484 17.9479 11.6716 17.8595C11.7947 17.7711 11.8882 17.6475 11.9398 17.5049L17.9398 1.00495C17.9909 0.872257 18.0032 0.727772 17.9753 0.588342C17.9474 0.448912 17.8805 0.320282 17.7823 0.217449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e9bee3a96142882a511ba5d70ad11fde.svg";
export { ForwardRef as ReactComponent };